import { useState } from "react";
import { DatePicker } from "antd";
import { Dayjs } from "dayjs";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";

interface IObjectFormInputDate {
  nameFirst: string;
  nameSecond: string;
  control: Control<any>;
  labelFirst?: string;
  labelSecond?: string;
  placeholderSecond?: string;
}

export const ObjectFormDate = ({
  nameFirst,
  labelFirst,
  nameSecond,
  labelSecond,
  control,
  placeholderSecond,
}: IObjectFormInputDate) => {
  const [startDate, setStartDate] = useState<Dayjs>();

  return (
    <div className="field-group">
      <FormItem
        name={nameFirst}
        control={control}
        label={labelFirst}
        style={{
          margin: 0,
        }}
      >
        <DatePicker
          value={startDate}
          onChange={setStartDate}
          placeholder={placeholderSecond}
          className="object-form-input"
          format="DD.MM.YYYY"
        />
      </FormItem>
      <FormItem
        control={control}
        name={nameSecond}
        label={labelSecond}
        style={{
          margin: 0,
        }}
      >
        <DatePicker
          value={startDate}
          onChange={setStartDate}
          // disabledDate={disabledDate(startDate)}
          placeholder={placeholderSecond}
          className="object-form-input"
          format="DD.MM.YYYY"
        />
      </FormItem>
    </div>
  );
};
